import { Stack, Title, Text, Button, Card } from "@mantine/core";
import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <Card ta="center" p="xl">
      <Stack gap="md" align="center">
        <Title order={1} size="4rem" c="dimmed">
          404
        </Title>
        <Title order={2}>Page Not Found</Title>
        <Text c="dimmed" maw={400}>
          The page you&apos;re looking for doesn&apos;t exist. It might have
          been moved, deleted, or you entered the wrong URL.
        </Text>
        <Button component={Link} to="/" size="lg">
          Go Home
        </Button>
      </Stack>
    </Card>
  );
}
